module.exports = "data:image/gif;base64,R0lGODlhBwAHAIABAAAAAP///yH5BAEAAAEALAAAAAAHAAcAAAIMjGGJmMH9mHQ0AlYAADs="


//////////////////
// WEBPACK FOOTER
// ./node_modules/tinymce/skins/lightgray/img/anchor.gif
// module id = 78
// module chunks = 0